module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-regular.41fb7b51.ttf";